export default "/images/vendor/flag-icons/flags/4x3/sv.svg?3a8b809db2ca58c045e6d2b0b1af3b70";